// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Web3Provider } from './contexts/Web3Context';
import { NotificationProvider } from './contexts/NotificationContext';
import { DarkModeProvider } from './contexts/DarkModeContext';
import Header from './components/Header';
import Footer from './components/Footer';
import BottomNavigation from './components/BottomNavigation';
import Home from './pages/Home';
import ProposalList from './pages/ProposalList';
import ProposalCreate from './pages/ProposalCreate';
import ProposalDetail from './pages/ProposalDetail';
import ProposalEdit from './pages/ProposalEdit';
import UserProfile from './pages/UserProfile';
import TokenList from './pages/TokenList';
import TokenDetail from './pages/TokenDetail';
import AboutPage from './pages/AboutPage';
import NotFound from './pages/NotFound';
import NotificationToast from './components/NotificationToast';
import AdminPanel from './pages/AdminPanel';

function App() {
  return (
    <Router>
      <DarkModeProvider>
        <Web3Provider>
          <NotificationProvider>
            <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
              <Header />
              <main className="flex-grow container mx-auto px-4 py-8 pt-20 pb-20 sm:pb-8">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/proposals" element={<ProposalList />} />
                  <Route path="/proposals/create" element={<ProposalCreate />} />
                  <Route path="/proposals/edit/:id" element={<ProposalEdit />} />
                  <Route path="/proposals/:id" element={<ProposalDetail />} />
                  <Route path="/user/:address" element={<UserProfile />} />
                  <Route path="/tokens" element={<TokenList />} />
                  <Route path="/tokens/:address" element={<TokenDetail />} />
                  <Route path="/about" element={<AboutPage />} />
                  <Route path="/admin" element={<AdminPanel />} />
                  <Route path="/404" element={<NotFound />} />
                  <Route path="*" element={<Navigate to="/404" />} />
                </Routes>
              </main>
              <Footer />
              <BottomNavigation />
              <NotificationToast />
            </div>
          </NotificationProvider>
        </Web3Provider>
      </DarkModeProvider>
    </Router>
  );
}

export default App;
